import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { RouteComponent } from '@app/route/route.component';
import {
  EmailAndPhone,
  UserService,
} from '@app/service/user-service/user.service';
import { HeaderService } from '@app/service/header/header.service';
import {
  StateControlParameters,
  StateService,
  ZaverProduct,
} from '@app/service/state/state.service';
import { email_validation_regexp } from '@assets/val/regexp';
import {
  formatPhoneNumber,
  phoneNumberValidator,
} from 'web-component-library/projects/component-library/src/public-api';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
import { LoggingService } from '@app/service/logging-service/logging.service';

@Component({
  selector: 'se-email-and-phone-registration',
  templateUrl: './se-email-and-phone-registration.component.html',
  styleUrls: [
    '../../page-shared.css',
    './se-email-and-phone-registration.component.scss',
  ],
})
export class SeEmailAndPhoneRegistrationComponent
  extends RouteComponent
  implements OnInit
{
  constructor(
    private formBuilder: FormBuilder,
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService,
    private valuePipe: ValuePipe,
    private loggingService: LoggingService
  ) {
    super(router, route, stateService, headerService);
  }
  form: FormGroup;
  showError = false;
  loading: boolean = true;
  modalActive: boolean = false;
  selectorItems: SelectorItem[] = null;
  selectedItem: SelectorItem;

  async ngOnInit(): Promise<void> {
    let contactDetails: EmailAndPhone;
    try {
      contactDetails = await this.userService.getContactDetailsSe();
    } catch (e) {
      // Navigates to the error page if the user is not registered. Only authenticated users should arrive here.
      this.loggingService.error('SE email registration: failed to fetch contact details', e);
      await this.navigate();
      return;
    }

    let email: string = '';
    let phoneNumber: string = '';
    if (!contactDetails) {
      console.log('No user details found.');
    } else {
      email = contactDetails.email !== null ? contactDetails.email : '';
      phoneNumber =
        contactDetails.phoneNumber !== null ? contactDetails.phoneNumber : '';
    }

    this.form = this.formBuilder.group({
      email: [
        email,
        [Validators.pattern(email_validation_regexp), Validators.required],
      ],
      phoneNumber: [
        phoneNumber,
        [phoneNumberValidator([46], this.state.market), Validators.required],
      ],
    });

    this.selectorItems = [
      {
        tab: 'Ditt köp',
        title: 'Sammanfattning',
        descriptions: [{ text: this.state.paymentInformation.description }],
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: `Totalbelopp inkl. moms: ${this.getTotalAmount()}`,
      },
    ];
    this.selectedItem = this.selectorItems[0];

    this.loading = false;
  }

  async handleCtaClick() {
    if (this.form.valid) {
      try {
        const formData: EmailAndPhone = {
          email: this.form.controls.email.value.trim().toLowerCase(),
          phoneNumber: formatPhoneNumber(
            this.form.controls.phoneNumber.value,
            this.state.market
          ),
        };
        const registerResp = await this.userService.registerEmailAndPhoneSE(
          formData
        );

        if (registerResp.success) {
          await this.navigate();
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      this.showError = true;
    }
  }

  backNavigationAllowed(): boolean {
    const checkoutProducts = [
      ZaverProduct.ECOM_CHECKOUT,
      ZaverProduct.IN_STORE_CHECKOUT,
    ];
    return !this.loading && checkoutProducts.includes(this.state.zaverProduct);
  }

  async reroute(): Promise<void> {
    const path: string = this.route.routeConfig.path;

    const controlParams: StateControlParameters = {
      currentPageName: this.stateService.getStepFromUrl(path),
      token: this.stateService.getToken(),
    };

    this.state = await this.stateService.reset(controlParams);
    const route = this.stateService.getRouteFromState(this.state);
    this.router.navigate([route], { queryParamsHandling: 'preserve' });
  }

  getTotalAmount(): string {
    return this.valuePipe.transform(this.state.totalCheckoutValue);
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }

  showPurchaseDetails(): void {
    this.toggleModal();
  }
}
